import { useSyncExternalStore } from 'react';
import {
  getUploadQueueSnapshot,
  subscribeUploadQueue,
  UploadQueueSnapshot,
} from '../services/uploadQueue';

/** Live counts from the background photo upload queue. */
export const useUploadQueue = (): UploadQueueSnapshot =>
  useSyncExternalStore(subscribeUploadQueue, getUploadQueueSnapshot, getUploadQueueSnapshot);
